import React from 'react';

import FireSvg from './assets/fire.svg';

export const Fire = () => (
  <div>
    <img src={FireSvg} alt="SVG Icon" title="fire" />
  </div>
);
